import { FC, useEffect } from "react";
import { ChatDTO, messengerApi } from "src/store/messenger";
import {
  useMessengerViewController,
  usePullMessageList,
} from "src/close-part/features/Messenger/hooks";
import { Spinner } from "@evvve/ui-kit";
import { MessageListPlaceholder } from "../message-list-placeholder";
import s from "./styles.module.scss";
import { MessageListGroupedVirtuoso } from "../message-list-grouped-virtuoso";

type Props = {
  chatInfo?: ChatDTO;
};

const MessageList: FC<Props> = ({ chatInfo }) => {
  const { chatId } = useMessengerViewController();

  const {
    messageListData,
    initialPartIsLoading,
    getInitialMessageList,
    initialPartIsUninitialized,
  } = usePullMessageList(chatId);

  const [getNextPartOfMessagesQuery] = messengerApi.useLazyGetMessageListQuery();

  const onLoadMoreMessages = () => {
    if (!messageListData || !chatId) throw new Error("TODO: обработать");

    const initialLastEvaluatedKey = messageListData.lastEvaluatedKey;

    if (initialLastEvaluatedKey) {
      // Нужно запрашивать только в случае если есть lastEvKey

      getNextPartOfMessagesQuery({
        chatId,
        lastEvaluatedKey: initialLastEvaluatedKey,
      });
    }
  };

  useEffect(() => {
    if (initialPartIsUninitialized) getInitialMessageList();
  }, [initialPartIsUninitialized, getInitialMessageList]);

  if (initialPartIsLoading) {
    return <Spinner size="l" color="grayscale400" className={s.spinner} />;
  }

  if (!messageListData?.data.length) {
    return <MessageListPlaceholder chatVariant={chatInfo?.type} />;
  }

  return chatInfo ? (
    <MessageListGroupedVirtuoso
      chatInfo={chatInfo}
      messageList={messageListData.data}
      loadMore={onLoadMoreMessages}
    />
  ) : null;
};

export default MessageList;
